module.exports = __webpack_public_path__ + "assets/logo.89a59557.svg";